(() => {
  // Display order only: moving existing controls preserves their commerce identities.
  const key = (capacity, label) => {
    const text = String(label || '').trim().toLowerCase();
    const raw = String(capacity || '').trim();
    const match = /^(\d+)(?:er\b|[a-z]\b|\s*(?:patronen|schuss)\b|$)/.exec(text);
    const number = /^\d+$/.test(raw) && Number(raw) > 0 ? Number(raw) : match ? Number(match[1]) : 0;
    if (!Number.isSafeInteger(number) || number <= 0) return [1, 0, ''];
    const suffix = /^\d+([a-z])\b/.exec(text) || /\bvariante\s+([a-z])\b/.exec(text);
    return [0, number, suffix?.[1] || ''];
  };
  const compare = (a, b) => a[0] - b[0] || a[1] - b[1] || a[2].localeCompare(b[2]);
  const ordered = (items, itemKey) => [...items].sort((a, b) => compare(itemKey(a), itemKey(b)));
  if (typeof module !== 'undefined' && module.exports) module.exports = {key, compare, ordered};
  if (typeof document === 'undefined') return;
  window.FilameltCapacityDisplay = {key, ordered};

  const reorder = (parent, items, itemKey, move = item => parent.append(item)) => {
    const sorted = ordered(items, itemKey);
    if (sorted.every((item, index) => item === items[index])) return;
    sorted.forEach(move);
  };
  const update = () => {
    document.querySelectorAll('variant-selects').forEach(picker => {
      picker.querySelectorAll('fieldset').forEach(fieldset => {
        const inputs = [...fieldset.querySelectorAll('input[type="radio"][data-fm-capacity]')];
        if (!inputs.length) return;
        const pairs = inputs.map(input => ({input, label: [...fieldset.querySelectorAll('label')].find(label => label.htmlFor === input.id)}));
        if (pairs.some(pair => !pair.label)) return;
        reorder(fieldset, pairs, pair => key(pair.input.dataset.fmCapacity, pair.input.value), pair => fieldset.append(pair.input, pair.label));
      });
      picker.querySelectorAll('select').forEach(select => {
        const options = [...select.options];
        if (!options.length || options.some(option => !option.hasAttribute('data-fm-capacity'))) return;
        const selected = select.value;
        reorder(select, options, option => key(option.dataset.fmCapacity, option.value));
        // Appending options must never change the active variant or dispatch a selection event.
        if (select.value !== selected) select.value = selected;
      });
    });
    document.querySelectorAll('.spf-product-card select[name="id"]').forEach(select => {
      const options = [...select.options];
      if (!options.length || options.some(option => key('', option.getAttribute('data-option1'))[0] !== 0)) return;
      const selected = select.value;
      reorder(select, options, option => key('', option.getAttribute('data-option1')));
      if (select.value !== selected) select.value = selected;
    });
    document.querySelectorAll('quick-order-list tbody').forEach(body => {
      const rows = [...body.querySelectorAll(':scope > tr.variant-item[data-fm-capacity]')];
      // Keep each variant's adjacent error row attached to its own controls.
      const groups = rows.map(row => ({row, error: row.nextElementSibling?.matches('.desktop-row-error') ? row.nextElementSibling : null}));
      reorder(body, groups, group => key(group.row.dataset.fmCapacity, group.row.dataset.fmCapacityLabel), group => {
        body.append(group.row);
        if (group.error) body.append(group.error);
      });
    });
    document.querySelectorAll('.fm-description__variants tbody').forEach(body => {
      const rows = [...body.children].filter(row => row.tagName === 'TR');
      reorder(body, rows, row => key('', row.cells[0]?.querySelector('strong')?.firstChild?.textContent || row.cells[0]?.textContent));
      [...body.children].filter(row => row.tagName === 'TR').forEach((row, index) => {
        const background = index % 2 ? 'rgb(251, 251, 249)' : '';
        if (row.style.background !== background) row.style.background = background;
      });
    });
  };
  let frame = null;
  const relevant = 'variant-selects, .fm-description__variants, quick-order-list, .spf-product-card';
  const observer = new MutationObserver(records => {
    if (!records.some(record => record.target.closest?.(relevant) || [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches(relevant) || node.querySelector(relevant))))) return;
    if (frame !== null) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      observer.disconnect();
      try { update(); } finally { observer.observe(document.body, {childList: true, subtree: true}); }
    });
  });
  update();
  observer.observe(document.body, {childList: true, subtree: true});
})();
